export default __webpack_public_path__ + "static/as-4cc8ecc96b406fde91c15692b8dee6ae.png";